type ApiCallConfig<T> = {
  endpoint: string;
  method: string;
  reshaper: (data: any) => T;
  body?: any;
};

export type APIResponse<T> = {
  data: T | null;
  status: number;
  error: string | null;
};

export const nextApiCall = async <T>({
  endpoint,
  method,
  body,
  reshaper,
}: ApiCallConfig<T>): Promise<APIResponse<T>> => {
  const errorMessage = 'unknown';
  const errorSatus = 0;

  try {
    const res = await fetch(endpoint, {
      method,
      body: JSON.stringify(body),
      redirect: 'follow',
      credentials: 'include',
    });
    if (res.status === 401) {
      return {
        data: null,
        status: res.status,
        error: 'unauthorized',
      };
    }
    if (res.ok) {
      const data = await res.json();
      return {
        data: reshaper(data),
        status: res.status,
        error: null,
      };
    }
    try {
      const error: { message: string } = await res.json();
      return {
        data: null,
        status: res.status,
        error: error.message,
      };
    } catch (_) {
      return {
        data: null,
        status: res.status,
        error: errorMessage,
      };
    }
  } catch (_) {
    return {
      data: null,
      status: errorSatus,
      error: errorMessage,
    };
  }
};
